import { useState, useRef } from "react";
import { Card, CardBody, CardText, Form, Row, Col } from "reactstrap";
// drop
import Dropzone from "react-dropzone";
// componentes
import ModeloUpload from "../../../assets/statics/modelo_veiculo_atualizar.xlsx";
import ModalExcelRows from "./ModalExcelRows";
// utils
import { formatBytes } from "../../../utils/helpers/files/formatBytes";
import {
  findRowsWithError,
  getUnregisteredEmails,
  getInvalidsIds,
  validCapacity,
} from "./importValidation";
import {
  allExcelColumnsUpdate,
  excelColumnsPtBrUpdate,
  getGoogleData,
  getInvalidsGroups,
} from "./importVehicleValidation";
// excel
import readXlsxFile from "read-excel-file";
// service
import { updateVehicle } from "../../../utils/services/vehicles";
import { getGroups } from "../../../utils/services/group";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";

export default function ImportUpdateVehicles(props) {
  const { toggle, eventId, getAllVehicles, participants, allVehicles } = props;
  // arquivos selecionados e envio
  const [selectedFiles, setselectedFiles] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [totalSended, setTotalSended] = useState(0);
  // botoes
  const [btnSend, setBtnSend] = useState(false);
  const [btnCancel, setBtnCancel] = useState(false);
  // importando
  const importActivated = useRef(false);
  // modal de erros no arquivo xlsx
  const [modalErrors, setModalErrors] = useState(false);
  const [errors, setErrors] = useState([]);
  // alerta
  const [success_dlg, setsuccess_dlg] = useState(false);

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setselectedFiles(files);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(true);
  }

  function cancelImport() {
    importActivated.current = false;
    setselectedFiles([]);
    setTotalRows(0);
    setTotalSended(0);
    setBtnSend(false);
    setBtnCancel(false);
  }

  async function uploadService() {
    importActivated.current = true;

    setBtnSend(false);
    setBtnCancel(true);

    const schema = {
      ID: {
        prop: "id",
        type: String,
      },
      "Tipo de Transfer": {
        prop: "transferType",
        type: String,
      },
      Nome: {
        prop: "description",
        type: String,
      },
      Origem: {
        prop: "origin",
        type: String,
      },
      Destino: {
        prop: "destination",
        type: String,
      },
      DataSaída: {
        prop: "departureDatetime",
        type: Date,
      },
      HoraSaída: {
        prop: "departureTime",
        type: String,
      },

      DataChegada: {
        prop: "arrivalDatetime",
        type: Date,
      },
      HoraChegada: {
        prop: "arrivalTime",
        type: String,
      },
      NomeDoMotorista: {
        prop: "driverName",
        type: String,
      },
      TipoVeículo: {
        prop: "vehicleType",
        type: String,
      },
      Capacidade: {
        prop: "seatingCapacity",
        type: Number,
      },
      Empresa: {
        prop: "company",
        type: String,
      },
      PontoDeEncontro: {
        prop: "meetingPoint",
        type: String,
      },
      TelefoneDoMotorista: {
        prop: "phone",
        type: String,
      },
      Observação: {
        prop: "notes",
        type: String,
      },
      Participantes: {
        prop: "participants",
        type: String,
      },
      NomeDoCoordenador: {
        prop: "coordinatorName",
        type: String,
      },
      TelefoneDoCoordenador: {
        prop: "coordinatorPhone",
        type: String,
      },
      Grupos: {
        prop: "groups",
        type: String,
      },
    };

    let count = 1;
    const readXlsx = async () => {
      // validar formato do documento
      const rowsWithoutSchema = await readXlsxFile(selectedFiles[0]);
      const schemaCreate = Object.keys(schema);
      const header = rowsWithoutSchema[0];

      function isEqual(schema, header) {
        if (schema.length !== header.length) return false;

        return (
          schema.every((item) => header.includes(item)) &&
          header.every((item) => schema.includes(item))
        );
      }

      if (!isEqual(schemaCreate, header)) {
        setErrors([]);
        setModalErrors(true);
        return;
      }

      // validar dados do documento
      const { rows } = await readXlsxFile(selectedFiles[0], { schema });
      const validateRows = rows.map((row, i) => allExcelColumnsUpdate(row, i));
      const rowsWithError = findRowsWithError(validateRows);

      setTotalRows(validateRows.length);

      if (rowsWithError.length > 0 || rows.length === 0) {
        setErrors(rowsWithError);
        setModalErrors(true);
        return;
      }

      // emails do campo participantes válidos
      const unregisteredEmails = await getUnregisteredEmails(
        validateRows,
        participants,
      );

      if (unregisteredEmails.length > 0 || rows.length === 0) {
        setErrors(unregisteredEmails);
        setModalErrors(true);
        return;
      }

      const invalidsIds = await getInvalidsIds(validateRows, allVehicles);

      if (invalidsIds.length > 0) {
        setErrors(invalidsIds);
        setModalErrors(true);
        return;
      }

      const getInvalidCapacity = await validCapacity(validateRows);

      if (getInvalidCapacity.length > 0) {
        setErrors(getInvalidCapacity);
        setModalErrors(true);
        return;
      }

      const getGroupsConst = await getGroups({
        jwt: "",
        eventId: eventId,
        offset: 1,
        limit: 0,
        search: "",
      });

      const allGroups =
        getGroupsConst.message === "Groups_by_event"
          ? getGroupsConst.findOneGroupData.data
          : [];

      const invalidsGroups = await getInvalidsGroups(
        validateRows,
        eventId,
        allGroups,
      );

      if (invalidsGroups.length > 0) {
        setErrors(invalidsGroups);
        setModalErrors(true);
        return;
      }

      const rowsWithGoogleData = await getGoogleData(validateRows);

      for (const row of rowsWithGoogleData) {
        await importUpdateVehicleService(
          row,
          rowsWithGoogleData.length,
          allGroups,
        );
      }
    };

    readXlsx();

    async function importUpdateVehicleService(row, totalRows, allGroups) {
      const groups = row.groups
        ? row.groups.split(",").map((e) => {
            const search = allGroups.find(
              (searchGroup) =>
                searchGroup.name.toUpperCase() === e.toUpperCase().trim(),
            );

            if (search) return search.id;
          })
        : [];

      var dataForm = {
        eventId,
        transferType: row.transferType.toUpperCase().replaceAll(" ", ""),
        description: row.description,
        origin: row.origin,
        destination: row.destination,
        departureLongitude: null,
        departureLatitude: null,
        arrivalLongitude: null,
        arrivalLatitude: null,
        departureDatetime:
          row.departureDatetime && row.departureTime
            ? `${inverterData(row.departureDatetime)}T${row.departureTime}`
            : null,
        arrivalDatetime:
          row.arrivalDatetime && row.arrivalTime
            ? `${inverterData(row.arrivalDatetime)}T${row.arrivalTime}`
            : null,
        driverName: row.driverName,
        coordinatorName: row.coordinatorName,
        coordinatorPhone: row.coordinatorPhone,
        vehicleType: row.vehicleType,
        seatingCapacity: parseInt(row.seatingCapacity),
        company: row.company,
        meetingPoint: row.meetingPoint,
        phone: row.phone,
        notes: row.notes,
        participants: row.participants
          ? row.participants
              .replaceAll(" ", "")
              .split(",")
              .map((email) => {
                const search = participants?.find(
                  (part) => part.email === email,
                );

                if (search) return search.id;
              })
          : [],
        grupos: groups,
      };

      await updateVehicle(dataForm, row.id)
        .then((res) => {
          if (res.message === "updated") {
            setTotalSended(count++);
          }

          if (count === totalRows || (count === 2 && totalRows === 1)) {
            setsuccess_dlg(true);
          }
        })
        .catch((error) => console.log("erro", error));
    }

    function inverterData(data) {
      const [dia, mes, ano] = data.split("-");
      return `${ano}-${mes}-${dia}`;
    }
  }

  return (
    <>
      {modalErrors && (
        <ModalExcelRows
          toggle={() => setModalErrors(false)}
          rows={errors}
          columnNames={excelColumnsPtBrUpdate}
        />
      )}

      {success_dlg ? (
        <SweetAlert
          success
          title={"Upload"}
          onConfirm={() => {
            toggle();
            setsuccess_dlg(false);
            getAllVehicles();
          }}
        >
          {"O arquivo foi enviado com sucesso!"}
        </SweetAlert>
      ) : null}

      <Card className="p-1">
        <CardBody className="m-1 p-2">
          <CardText className="mb-2 p-10">
            O arquivo a ser importado deve seguir este{" "}
            <a href={ModeloUpload} download="modelo_veiculo_atualizar.xlsx">
              Modelo
            </a>
            , não modifique seu cabeçalho.
          </CardText>

          <Form>
            {selectedFiles.length === 0 && (
              <Dropzone
                onDrop={(acceptedFiles) => {
                  handleAcceptedFiles(acceptedFiles);
                }}
              >
                {({ getRootProps, getInputProps }) => (
                  <div className="dropzone">
                    <div
                      className="dz-message needsclick mt-1"
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <div className="mb-4">
                        <i className="display-4 text-muted bx bxs-cloud-upload" />
                        <h4>Arraste o arquivo ou clique aqui e selecione.</h4>
                      </div>
                    </div>
                  </div>
                )}
              </Dropzone>
            )}
            <div className="dropzone-previews mt-0" id="file-previews">
              {selectedFiles.map((f, i) => {
                return (
                  <Card
                    className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                    key={i + "-file"}
                  >
                    <div className="p-1">
                      <Row className="align-items-center">
                        <Col xs="11">
                          <strong>{`Nome: ${f.name} - Tamanho: ${f.formattedSize}`}</strong>
                        </Col>
                        <Col xs="1">
                          <span
                            style={{
                              fontSize: "16px",
                              color: "red",
                              fontWeight: "700",
                            }}
                            className="mdi mdi-close"
                            onClick={() => setselectedFiles([])}
                          />
                        </Col>
                      </Row>
                      {importActivated.current && (
                        <Row className="align-items-center">
                          <Col>
                            <strong>{`Total enviado: ${totalSended}/${totalRows}`}</strong>
                          </Col>
                        </Row>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          </Form>

          <div className="text-center mt-3">
            <button
              type="button"
              disabled={!btnSend}
              className="btn btn-primary waves-effect waves-light"
              onClick={() => uploadService()}
            >
              Enviar Veículos
            </button>
            <button
              type="button"
              className="btn btn-danger mx-1"
              disabled={!btnCancel}
              onClick={() => cancelImport()}
            >
              Cancelar
            </button>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
